import _regeneratorValues from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regeneratorKeys from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "house-deleted",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        type: 3,
        houseStatus: -1 // houseStatus 0 为删除
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      remarkDialogVisible: false,
      currentRemarkObj: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getHouseFilterType();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    updateItem: function updateItem(row) {
      var params = new URLSearchParams({
        id: row.id,
        userId: row.userInfo.id,
        from: "house_deleted_edit"
      });
      window.open("#/house/update?".concat(params.toString()));
    },
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row;
      this.remarkDialogVisible = true;
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getUsersTagList: function getUsersTagList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var userIds, res, _loop, key, _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              userIds = [];
              _this2.tableData.forEach(function (item) {
                if (userIds.indexOf(item.userInfo.id) == -1) {
                  userIds.push(item.userInfo.id);
                }
              });
              _context3.n = 1;
              return _this2.$api.getUsersTagList({
                top: 5,
                user_id: userIds.join(",")
              });
            case 1:
              res = _context3.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(key) {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.tableData.forEach(function (item, index) {
                        if (item.userInfo.id == key) {
                          _this2.$set(item, "userTag", res.data[key]);
                        }
                      });
                    case 1:
                      return _context2.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context3.n = 4;
                break;
              }
              key = _t2.value;
              return _context3.d(_regeneratorValues(_loop(key)), 3);
            case 3:
              _context3.n = 2;
              break;
            case 4:
              return _context3.a(2);
          }
        }, _callee2);
      }))();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              _this3.tableLoading = true;
              _context4.n = 1;
              return _this3.$api.getHouseList(_this3.searchForm);
            case 1:
              res = _context4.v;
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
              _this3.tableData.forEach(function (item) {
                return item.userId = item.userInfo.id;
              });
              _this3.getUserListByIds(_this3.tableData, "userId", '', 'newUser');
              _context4.n = 2;
              return _this3.getUsersTagList();
            case 2:
              return _context4.a(2);
          }
        }, _callee3);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this4.$api.getHouseFilterType();
            case 1:
              res = _context5.v;
              _this4.filterList = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee4);
      }))();
    },
    getDistrictList: function getDistrictList(val) {
      var _this5 = this;
      if (val) {
        this.filterList.cityList.forEach(function (value) {
          if (value.id === val) {
            _this5.searchForm.districtId = "";
            _this5.districtList = value.item;
          }
        });
      } else {
        this.districtList = [];
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row;
      if (row.blackIp) {
        return "black-ip-row";
      }
      return "";
    }
  }
};